import axios from './http'

export default {
    getAll(){
        return axios.get('/menu')
        .then(function (response) {
            // console.log(response)
            return Promise.resolve(response)
        })
        .catch(function (error) {
            return Promise.reject(error)
        });
    }
}